import a1 from "./1.mp3";
import a2 from "./2.mp3";
import a3 from "./5.mp3";
import KV_Music from "./KV_Music.webp";
import LandingWoM from "./LandingWoM.webp";

const audios = [{
        thumbnail: KV_Music,
        src: a1,
        title: "Chiến đấu",
    },
    {
        thumbnail: KV_Music,
        src: a2,
        title: "Chiến đấu",
    },
    {
        thumbnail: KV_Music,
        src: a3,
        title: "Chiến đấu",
    },
];

export default audios;